import {ConditionBase} from "./ConditionBase";
import {Condition} from "../AdvancedSearchControls";
import * as React from "react";

export class TextCondition extends ConditionBase{
    GetComparisons(): { Label: string; Value: string }[] {
        return [
            {Label:'Equal',Value:'='},
            {Label:'Not Equal',Value:'<>'},
            {Label:'Contains',Value:'like'},
            {Label:'Not Contains',Value:'not like'}

        ];
    }

    GetValueEditor(condition: Condition, callback: () => void): React.ReactElement<any, string | React.JSXElementConstructor<any>> {
        return (
            <div className={'rncontrol'}>
                <label/>
                <input style={{width:'100%'}} type={'text'} value={condition.Value} onChange={x=>{condition.Value=x.target.value;callback();}} />
            </div>
        );
    }

}